import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var UserService = /** @class */ (function () {
    function UserService(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    UserService.prototype.get_direccion_rol = function (rol) {
        var params = {
            rol: rol
        };
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/get_dir_rol', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.get_direccion_callenum = function (calle, num) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            calle: calle,
            num: num
        };
        return this._http.post(this.url + 'user/get_dir_callenum', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.get_predio = function (rol) {
        var params = {
            rol: rol
        };
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/get_predio', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.get_certificado = function (numSolic) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var paramas = {
            numSolic: numSolic
        };
        console.log("manda el numsol ", numSolic);
        return this._http.post(this.url + 'user/get_ccertificado', paramas, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.get_expediente = function (numSolic, rut) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var paramas = {
            numSolic: numSolic,
            rut: rut
        };
        //console.log("manda el numsol ", numSolic)
        return this._http.post(this.url + 'user/get_expediente', paramas, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getPropietario = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/propietario', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.savePropietario = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        //console.log("save propietario user:",user)
        return this._http.post(this.url + 'save/propietario', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveRepresentante = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/representante', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getRepresentante = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/representante', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveinspector_obra = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/inspectorObra', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getinspector_obra = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/inspectorObra', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveprofesional_comp = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/profesionComp', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getprofesional_comp = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/profesionComp', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getArquitecto = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/arquitecto', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveArquitecto = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/arquitecto', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getIndependiente = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/independiente', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveIndependiente = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/independiente', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getEmpresa = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/empresa', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveEmpresa = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/empresa', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getConstructores = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/constructores', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveConstructores = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/constructores', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getConstructora = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/constructora', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveConstructora = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/constructora', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getCalculista = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/calculista', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveCalculista = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/calculista', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getRevisor = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'get/revisor', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveRevisor = function (user) {
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/revisor', user, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.login = function (rut, password, getToken) {
        if (getToken === void 0) { getToken = null; }
        var params;
        if (getToken != null) {
            params = {
                rut: rut,
                password: password,
                getToken: getToken
            };
        }
        else {
            params = {
                rut: rut,
                password: password
            };
        }
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/login', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.register = function (user) {
        var params = {
            rut: user.controls.rut.value,
            nombres: user.controls.nombres.value,
            apellidoP: user.controls.apellidoP.value,
            apellidoM: user.controls.apellidoM.value,
            profesion: user.controls.profesion.value,
            calle: user.controls.calle.value,
            numero: user.controls.numero.value,
            complemento: user.controls.complemento.value,
            comuna: user.controls.comuna.value,
            email: user.controls.email.value,
            telefono: user.controls.telefono.value,
            password: user.controls.passwords.controls.password.value
        };
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/register', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.buscarUsuario = function (rut) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            rut: rut
        };
        return this._http.post(this.url + 'user/find', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveDraft = function (name, draft) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        console.log("aca vá el borrador", draft);
        var params = {
            name: name,
            draft: draft,
            form: localStorage.getItem("form")
        };
        return this._http.post(this.url + 'user/save/draft', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getDrafts = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.get(this.url + 'user/get/drafts', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getDraft = function (id) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            formId: id
        };
        return this._http.post(this.url + 'user/get/draft', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getIdentity = function () {
        var identity = JSON.parse(sessionStorage.getItem('identity-domCloud'));
        if (identity != "undefined") {
            this.identity = identity;
        }
        else {
            this.identity = null;
        }
        return this.identity;
    };
    UserService.prototype.getToken = function () {
        var token = sessionStorage.getItem('token-domCloud');
        if (token != undefined) {
            this.token = token;
        }
        else {
            this.token = null;
        }
        return this.token;
    };
    UserService.prototype.getActiveCertificado = function () {
        var token = sessionStorage.getItem('activeCertificado');
        if (token != undefined) {
            this.token = token;
        }
        else {
            this.token = null;
        }
        return this.token;
    };
    UserService.prototype.deleteDraft = function (draft) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'draft/delete', draft, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.updateDraft = function (id, draft) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            draft: draft,
            draftId: id
        };
        return this._http.post(this.url + 'draft/update', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.updatePhoto = function (img) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            img: img
        };
        return this._http.post(this.url + 'user/profile/img/update', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.formMostUsed = function (id, title) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            num: id,
            title: title,
            counter: 1
        };
        return this._http.post(this.url + 'forms/update/most', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getFormularios = function () {
        var params = {};
        var headers = new Headers({
            'Content-Type': 'application/json'
            //,'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'forms/getFormularios', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getFormUser = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.get(this.url + 'forms/get/most', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getSolicitudes = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        //console.log( "solicitudes", this._http.get(this.url+'solicitudes/expedientes/get', {headers:headers}) );
        return this._http.get(this.url + 'solicitudes/expedientes/get', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.activeUser = function (token) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            token: token
        };
        return this._http.post(this.url + 'user/active', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getComunas = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
        });
        return this._http.get(this.url + 'comunas', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getRegiones = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
        });
        return this._http.get(this.url + 'regiones', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.resendMailActivation = function (email) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            email: email
        };
        return this._http.post(this.url + 'email/resend', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.marcarSolicitud = function (solicitud) {
        var headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        var params = {
            solicitud: solicitud
        };
        return this._http.post(this.url + 'solicitud/marcar', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.sendMailResetPass = function (rut, email) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            rut: rut,
            mail: email
        };
        return this._http.post(this.url + 'email/reset/pass', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.resetPass = function (rut, password) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            rut: rut,
            pass: password
        };
        return this._http.post(this.url + 'user/reset/pass', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.askForMail = function (rut) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var paramas = {
            rut: rut
        };
        return this._http.post(this.url + 'user/ask/mail', paramas, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.saveNewMail = function (rut, mail) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var paramas = {
            rut: rut,
            mail: mail
        };
        return this._http.post(this.url + 'user/new/mail', paramas, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.traerInfo_rut = function (rut) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            rut: rut
        };
        return this._http.post(this.url + 'user/getinfo_rut', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.save_solicitante = function (user) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var paramas = {
            user: user
        };
        return this._http.post(this.url + 'user/saveSolicitante', paramas, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.save_info_mod_solicitante = function (rut, data) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            rut: rut,
            data: data
        };
        return this._http.post(this.url + 'user/guardar_mod_solicitante', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getCalles = function () {
        var headers = new Headers({
            'Content-type': 'application/json'
        });
        return this._http.get(this.url + 'get/calles', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.get_valores_cert = function () {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        return this._http.post(this.url + 'user/get_valores_cert', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.traerInfo_propiedad_rol = function (rol) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            rol: rol
        };
        return this._http.post(this.url + 'user/getinfo_propiedad_rol', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.traerInfo_propiedad_direccion = function (calle, num) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            calle: calle,
            num: num
        };
        return this._http.post(this.url + 'user/getinfo_propiedad_direccion', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.beforePago = function (datos) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            datos: datos
        };
        return this._http.post(this.url + 'user/beforePago', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.casWsConsumo = function (total, inforut, carro_cas) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            total: total,
            inforut: inforut,
            carro: carro_cas
        };
        return this._http.post(this.url + 'user/casConsumo', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.casWsConsumoCuentas = function (total, inforut, carro_cas, valorOnlyCert, valorEstampilla, cantidaCert) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            total: total,
            inforut: inforut,
            carro: carro_cas,
            valorOnlyCert: valorOnlyCert,
            valorEstampilla: valorEstampilla,
            cantidaCert: cantidaCert,
        };
        return this._http.post(this.url + '/user/casConsumoCuentas', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.casWsCreateGiro = function (total, totalformat, inforut, carro_cas, itemPago, certs, obs, dbx_links) {
        var headers = new Headers({
            'Content-Type': 'application/json'
        });
        var params = {
            total: total,
            inforut: inforut,
            carro: carro_cas,
            itempago: itemPago,
            totalformat: totalformat,
            certs: certs,
            obs: obs,
            dbx_links: dbx_links
        };
        return this._http.post(this.url + '/user/casCreateGiro', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.getTipoIngreso = function () {
        var headers = new Headers({
            'Content-Type': 'application/json',
        });
        console.log('Inspeccion Service', this.url);
        return this._http.get(this.url + 'tipoIngreso', { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.crearInspeccion = function (data) {
        console.log(data);
        var headers = new Headers({
            'Content-type': 'application/json',
        });
        return this._http.post(this.url + 'save/inspeccion', data, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    UserService.prototype.uploadFiles = function (files, formType) {
        if (formType === void 0) { formType = ''; }
        var formData = new FormData();
        formData.append('formType', formType);
        files.map(function (file) {
            if (!(file == null || file == undefined)) {
                var doExt = file.doc.name.split(".");
                doExt = file.name + '-' + new Date().getTime() + '.' + doExt[doExt.length - 1];
                var fil = void 0;
                fil = file.doc;
                formData.append('uploads[]', fil, doExt);
            }
        });
        return this._http.post(this.url + 'upload/dbx', formData)
            .pipe(map(function (res) { return res.json(); }));
    };
    return UserService;
}());
export { UserService };
